import React from 'react';
import { IVocabDecksPageDeck } from '@/components/common/VocabularyCards/interfaces';
import Icon from '@/components/ui/Icon';
import cn from '@/utils/cn';

const DeckUserIcon = ({ deck }: { deck: IVocabDecksPageDeck }) => {
  // TODO: Replace TCI image icon with SVG
  const stafferInitials = `${deck.staffer.first_name.charAt(0)}${deck.staffer.last_name.charAt(0)}`;

  return (
    <div
      className={cn('tw-rounded-full tw-box-border tw-p-0.5 tw-flex tw-items-center',
        'tw-justify-center tw-absolute tw-bottom-1 tw-right-1',
        { 'tw-bg-tci-purple tw-w-4 tw-h-4': deck.staffer_id === 0 })}
    >
      {deck.staffer_id === 0 ? (
        <Icon className="tw-text-tci-purple" icon="TCI" size={16} />
      ) : (
        <Icon className="tw-text-green" icon="Initials" initialsText={stafferInitials} size={16} />
      )}
    </div>
  );
};

export default DeckUserIcon;
